


// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';
import { Mixins } from 'vue-mixin-decorator';

// // Models
import Bill, { TransactionType } from '@/manager/billing/models/bill.model';
import BillLine from '@/manager/billing/models/bill-line.model';
import { TypeOfProduct } from '@/manager/product/models/product.model.ts';
import { PaymentMethod, PaymentMethodLiteral } from '@/clickbuy/purchase/models/purchase.model';

// Components
import Field from '@/shared/components/field.component.vue';
import GroupButton from '@/shared/components/group-button.component.vue';
import Input from '@/shared/components/input.component.vue';

// Views
import ShoppingCartLineBill from '@/manager/billing/views/edit-bill-modal/shopping-cart/shopping-cart-line/index.vue';
import ShoppingCartLineBillReceived from '@/manager/billing/views/edit-bill-modal/shopping-cart/shopping-cart-line-received/index.vue';


@Component({
    components: {
        Field,
        Input,
        GroupButton,
        ShoppingCartLineBill,
        ShoppingCartLineBillReceived,
    },
    methods: {
        ...mapActions({
            fetchProductList: 'fetchProductList',
        }),
    },
    computed: {
        ...mapGetters({
            getProfile: 'getProfile',
            bill: 'getCurrentBill',
        }),
    },
})
export default class ShoppingCartBill extends Vue {
    @Prop({ default: TransactionType.TransactionEmitted }) private transactionType!: number;
    @Prop({ default: false }) private modifyDataPrivate!: boolean;
    @Prop({ default: false }) private opened!: boolean;
    private fetchProductList!: any;
    private bill!: any;
    private productResponse = false


    private created() {
        this.fetchAllProductList();
    }


    get billTotalWithoutTax() {
        let total = 0;
        total = (this.bill as any).billLine.reduce(
            (total: number, line: any) => {
                if ( line.totalPriceWithoutTax ) {
                    return total + line.totalPriceWithoutTax;
                } else {
                    return total;
                }
            },
            0,
        );
        return total;
    }

    get billTotal() {
        let total = 0;
        total = (this.bill as any).billLine.reduce(
            (total: number, line: any) => {
                if ( line.totalPrice ) {
                    return total + line.totalPrice;
                } else {
                    return total;
                }
            },
            0,
        );
        this.bill.totalPrice = total;
        return total;
    }

    get paymentMethodOptions() {
        return [
            {
                id: String(PaymentMethod.Cash),
                text: PaymentMethodLiteral[PaymentMethod.Cash],
            },
            {
                id: String(PaymentMethod.Card),
                text: PaymentMethodLiteral[PaymentMethod.Card],
            },
            {
                id: String(PaymentMethod.DirectDebit),
                text: PaymentMethodLiteral[PaymentMethod.DirectDebit],
            },
            {
                id: String(PaymentMethod.SendWireTransfer),
                text: PaymentMethodLiteral[PaymentMethod.SendWireTransfer],
            },
            {
                id: String(PaymentMethod.Bizum),
                text: PaymentMethodLiteral[PaymentMethod.Bizum],
            },
            {
                id: String(PaymentMethod.Web),
                text: PaymentMethodLiteral[PaymentMethod.Web],
            },
        ];
    }

    get firstColumnName() {
        let name = 'Producto*';
        if ( this.transactionTypeIsReceived ) {
            name = 'Concepto*';
        }
        return name;
    }

    get transactionTypeIsReceived() {
        return this.transactionType === TransactionType.TransactionReceived;
    }


    private fetchAllProductList(callback: any = () => { const a = 1; }) {
        this.$store.dispatch("fetchProductList", {limit: 1000}).then(
            (res) => {
                this.checkProductResponse(true)
                           
            }
        );
    }

    private checkProductResponse(newVal: any) {
        if (newVal != null) {
            this.productResponse =  true     
        } else {
            this.productResponse =  false     
        }
    }

    private removeLine(line: BillLine) {
        const lines = (this.bill as any).billLine;
        const index = lines.indexOf(line);
        lines.splice(index, 1);
    }

    private newLine() {
        const newLine = new BillLine();
        (this.bill as any).billLine.push(newLine);
    }

    private paymentMethodSelected(paymentMethod: string) {
        this.bill.paymentMethod = Number(paymentMethod);
    }
}
